<template>
    <!-- Footer -->
    <footer class="sticky-footer bg-white">
        <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>Copyright &copy; 中央大學企業重整/再生與破產法制研究中心 2023</span>
        </div>
        </div>
    </footer>
    <!-- End of Footer -->
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  created() {

      window.addEventListener('beforeunload', this.test)  

  },
  mounted() {
  },
  methods: {
    test(){
      
      const pasteText = document.querySelector('#cke_93_textInput');
      pasteText.focus();
      document.execCommand('paste');
     
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/Footer.vue